<template>
  <div>
     <el-tabs v-model="activeTab">
      <el-tab-pane label="Scenario" name="scenario">
            <div class="block" id="botContainer">
        <el-row id="controlButtonsRow">
          <el-col :span="12">
            <span class="pageHeader">{{bot.data.name}} 
              from 
              <el-tooltip content="go to project" placement="top">
                <router-link :to="getLink">{{ project.data.name }}</router-link>
              </el-tooltip>
            </span>
          </el-col>
          <el-col id="controlButtonsCol" :span="12">
            <RunNow :displayType="'button'" :project_id="$route.params.project_id" :bot_id="$route.params.id" />
             <el-input
              id="copyInput"
              v-if="copy.visible"
              placeholder="enter copy name"
              v-model="copy.name"
              clearable>
             </el-input>
            <el-button v-if="!copy.visible" v-on:click="setCopy(true)" type="warning">Copy bot</el-button>
            <el-button v-if="copy.visible" v-on:click="copyBot()" type="danger">Save copy</el-button>
            <el-button v-if="copy.visible" v-on:click="setCopy(false)" type="warning">Don't copy</el-button>
            <el-input
              id="renameInput"
              v-if="renameVisible"
              placeholder="enter bot name"
              v-model="$store.state.bot.bot.data.name"
              clearable>
            </el-input>
            <el-button v-if="renameVisible" v-on:click="setRename(false)" type="danger">Cancel</el-button>
            <el-button v-if="!renameVisible && !copy.visible" v-on:click="setRename(true)" type="info">Rename</el-button>
            <el-button v-loading="loading" v-on:click="saveBot()" type="danger">Save</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <Actions />
          </el-col>
          <el-col :span="8">
            <Scenario />
          </el-col>
          <el-col :span="10" id="settingsCol">
              <Settings />
          </el-col>
        </el-row>
        
    </div>
      </el-tab-pane>
       
      <el-tab-pane label="Settings" name="settings">
        <el-col :span="8">
          <el-row>
              <div class="block inputContainer">
                <el-divider content-position="left">Tags</el-divider>
                <el-col :span="16" class="specControl">
                    <el-row>
                        <el-tag
                            v-for="tag in bot.data.tags"
                            :key="tag"
                            closable
                            @close="handleCloseIncludeTags(tag)"
                            >
                            {{tag}}
                        </el-tag>
                    </el-row>
                    <el-row>
                        <el-col :span="16">
                            <el-input id="tagInput" v-model="tagIncludeInput" clearable=""></el-input>
                        </el-col>
                        <el-col align="right" :span="8">
                            <el-button id="addTagButton" @click="addIncludeTag()" type="info">Add tag</el-button>
                        </el-col>
                    </el-row>
                </el-col>
              </div>
          </el-row>
          <el-row>
            <el-button  v-on:click="saveBot()" size="large" type="danger">Save tags</el-button>
          </el-row>
        </el-col>
        
        
      </el-tab-pane>
    </el-tabs>

    
  </div>
  
</template>

<style lang="scss" scoped>
  #tagInput {
    padding:0px !important;
  }
  #botTags {
    padding:15px;
    width: 500px;
  }
  a {
    color: grey;
    font-weight: 300;    
    text-decoration: underline !important;
  }
  a:hover {
    text-decoration: underline !important;
    color: orange;
  }
  #botContainer {
    margin-top:40px;
  }
  .pageHeader{
    font-size:25px;
    color:#555;
  }
  #controlButtonsRow{
    margin-bottom:10px;
  }
  #controlButtonsCol{
    text-align: right;
  }
  #settingsCol {
    padding-left:10px;
  }
  #controlButtonsCol .el-input{
    display: inline-block;
    width:200px;
    margin-left:10px !important;
    margin-right:10px !important;
  }
</style>
<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import draggable from 'vuedraggable';
import Vue from 'vue';
import Actions from './Actions'
import Scenario from './Scenario'
import Settings from './Settings'
import $router from '../../router'
import RunNow from '../project/Scheduler/Bot/RunNow.vue';

Vue.component('draggable', draggable);
export default {
  name: 'BotPage',
  components: {
    draggable,
    Actions,
    Scenario,
    Settings,
    RunNow
  },
  beforeDestroy() {
    //alert('destroyed');
    this.$store.state = {
      loading: false,
      error: false,
      items: [],
      project: [],
      bot: [],
      advanced: {},
      playbooks: [],
      playbooksEdits:{
        result: {}
      },
      idToEdit: 0,
      pagination: {
        limit: 10,
        page: 0,
        total: 0
      }
    }
  },
  mounted: function () {
      var that = this;
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'bot/BOT_COPIED') {
          $router.push({ name: 'bot', params: { project_id: that.$route.params.project_id,id: mutation.payload.data.id } });
        }
    })
  },
  methods: {
    handleCloseIncludeTags(tag) {
        this.bot.data.tags.splice(this.bot.data.tags.indexOf(tag), 1);
    },
    addIncludeTag() {
        if (this.tagIncludeInput.length) {
            this.bot.data.tags.push(this.tagIncludeInput);
            this.tagIncludeInput = '';
        }
    },
    copyBot() {
      var model = {
        bot_id: this.$route.params.id,
        project_id: this.$route.params.project_id,
        name: this.copy.name
      }
      this.$store.dispatch('bot/copyBot', {model: model});
    },
    setCopy(value) {
      this.copy.visible = value;

      if (value) {
        this.copy.name = this.$store.state.bot.bot.data.name + ' [copy]'
      }
    },
    setRename(value) {
      this.renameVisible = value;
    },
    fetchData() {
      this.$store.dispatch('bot/loadBot', {params: {
        id:this.$route.params.id,
        project_id:this.$route.params.project_id
        }});
    },
    saveBot() {
      //prepare bot model
      var model = this.$store.state.bot.bot.data;
      /*var model = {
        id: this.$route.params.id,
        project_id: this.$route.params.project_id,
        name: this.$store.state.bot.bot.data.name,
        scenario: JSON.parse(JSON.stringify(this.$store.state.bot.bot.data.scenario))
      }*/
      model.scenario = this.$store.state.bot.bot.data.scenario;
      
      
      model.project_id = this.$route.params.project_id;
      model.id = this.$route.params.id;
      

      this.renameVisible = false;
      this.$store.dispatch('bot/updateBot', {model: model});
    }
  }, 
  data () {
    return {
      activeTab: "scenario",
      dialogNow: {
        visible: false,
        delay: 0,
        tasks: 0,
        repeats: 0,
        bot_id: -1,
        project_id:-1,
      },
      tags: [],
      tagIncludeInput: '',
      renameVisible:false,
      copy: {
        visible:false,
        name: ''
      }
    }
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading',
    }),
    getLink() {
      return '/project/' + this.bot.data.project_id;
    }
  },
  created () {
    this.fetchData();
  }
}
</script>
